/**
 * Type guard for SharedWorkerRequestMessage
 */
export function isSharedWorkerRequestMessage(obj) {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  switch (obj.requestType) {
    case "startFileUpload":
      return typeof obj.id === "string" && typeof obj.params === "object";
    case "heartbeat":
      return typeof obj.tabId === "string";
    case "cancelFileUpload":
      return typeof obj.id === "string";
    case "setMaxConcurrentUploads":
    case "setMaxConcurrentChunks":
    case "setMaxConcurrentUploadsAuto":
    case "setChunkSize":
      return typeof obj.value === "number";
    case "setUploadEndpoint":
      return typeof obj.endpoint === "string";
    default:
      // This ensures that all cases are handled
      obj;
      return false;
  }
}

/**
 * Type guard for SharedWorkerResponseMessage
 */
export function isSharedWorkerResponseMessage(obj) {
  if (typeof obj !== "object" || obj === null || obj === undefined) {
    return false;
  }
  if (typeof obj.responseType !== "string") {
    return false;
  }
  switch (obj.responseType) {
    case "onProgress":
      return typeof obj.arg === "object" && typeof obj.id === "string";
    case "onComplete":
      return typeof obj.arg === "object" && typeof obj.id === "string";
    case "onError":
      return typeof obj.arg === "object" && typeof obj.id === "string";
    case "onCanceled":
      return typeof obj.arg === "object" && typeof obj.id === "string";
    case "onConnectTab":
      return typeof obj.tabId === "string";
    case "onSetUploadEndpoint":
      return typeof obj.uploadEndpoint === "string";
    default:
      // This ensures that all cases are handled
      obj;
      return false;
  }
}